export default __webpack_public_path__ + "static/media/background.456fd60c.png";